import { gis2QueryUrl } from "../../utils/urls.js"
import { CIRCLE_RADIUS, CIRCLE_STROKE_WIDTH } from "../layerDefsConfig";

const newCimLayer = (id, arcLayerNumber, label) => {
  return {
    layer: {
      id: id, // <--------------------------------------------- id
      type: "circle",
      paint: {
        "circle-color": "#9E0059",
        "circle-radius": CIRCLE_RADIUS,
        "circle-stroke-width": CIRCLE_STROKE_WIDTH,
        "circle-stroke-color": "#fff",
      },
      layout: {
        visibility: "none",
      },
    },
    source: {
      id: id, // <--------------------------------------------- id
      type: "geojson",
      data: gis2QueryUrl(
        "Cultural_infrastructure_2023_for_webapp_verified",
        arcLayerNumber, // <----------------------------------- arcLayerNumber
      ),
    },
    labels: {
      parent: label, // <-------------------------------------- label
    },
    filters: { filterByChildren: false },
    filterBySelectedRegion: true,
    category: "culture",
    popupAttributes: ["name"],
    grouping: "culture-infrastructure",
  }
}

export const cultureLayerDefsCim = {
  "culture-infrastructure-archives": newCimLayer("culture-infrastructure-archives", 0, "Archives"),
  "culture-infrastructure-artists-workspaces": newCimLayer("culture-infrastructure-artists-workspaces", 1, "Artists workspaces"),
  "culture-infrastructure-arts-centres": newCimLayer("culture-infrastructure-arts-centres", 1, "Arts centres"),
  "culture-infrastructure-dance-performance-venues": newCimLayer("culture-infrastructure-dance-performance-venues", 8, "Dance performance venues"),
  "culture-infrastructure-dance-rehearsal-studios": newCimLayer("culture-infrastructure-rehearsal-studios", 9, "Dance rehearsal studios"),
  "culture-infrastructure-fashion-and-design": newCimLayer("culture-infrastructure-fashion-and-design", 10, "Fashion and design"),
  "culture-infrastructure-heritage-at-risk": newCimLayer("culture-infrastructure-heritage-at-risk", 11, "Heritage at risk"),
  "culture-infrastructure-legal-street-art-walls": newCimLayer("culture-infrastructure-legal-street-art-walls", 14, "Legal street art walls"),
  "culture-infrastructure-lgbt+-night-time-venues": newCimLayer("culture-infrastructure-lgbt+-night-time-venues", 15, "LGBT+ night time venues"),
  "culture-infrastructure-live-in-artists'-workspace": newCimLayer("culture-infrastructure-live-in-artists", 18, "Live in artists' workspace"),
  "culture-infrastructure-makerspaces": newCimLayer("culture-infrastructure-makerspaces", 19, "Makerspaces"),
  "culture-infrastructure-theatre-rehearsal-studio": newCimLayer("culture-infrastructure-theatre-rehearsal-studio", 34, "Theatre rehearsal studio"),
  "culture-infrastructure-theatres": newCimLayer("culture-infrastructure-theatres", 35, "Theatres"),
};